import { ComponentFields } from '@sitecore-jss/sitecore-jss-nextjs';

import { mapResourcePageToContentDetails } from 'src/mappers/models/resourcePageMapper';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';

import { isLmsCourse, isRcniCPDArticle, isRcniLearningModule, isResourcePage } from 'src/utils/isTemplate';

import RcniLinkFields from 'src/components/contentOverview/RcniLinkFields';
import WildCardFields from 'src/components/contentOverview/WildCardFields';

import { mapCPDArticleToContentDetails } from './cpdArticleMapper';
import { mapLearningModuleToContentDetails } from './learningModuleMapper';
import { mapLMSCourseToContentDetails } from './lmsCourseMapper';

export function mapFieldsToContentDetails(
	id: string,
	fields: ComponentFields | undefined,
	wildCardFields: WildCardFields & RcniLinkFields
): ContentDetailItem | null {
	try {
		let contentDetailsItem: ContentDetailItem | null = null;

		if (isResourcePage(wildCardFields?.WildCardContentTemplateId)) {
			contentDetailsItem = mapResourcePageToContentDetails(id ?? '', fields, wildCardFields.WildCardContentUrl);
		} else if (isLmsCourse(wildCardFields?.WildCardContentTemplateId)) {
			contentDetailsItem = mapLMSCourseToContentDetails(id ?? '', fields);
		} else if (isRcniCPDArticle(wildCardFields?.WildCardContentTemplateId)) {
			contentDetailsItem = mapCPDArticleToContentDetails(
				id ?? '',
				fields,
				wildCardFields.RCNiSAMLIdPBaseUrl,
				wildCardFields.RCNiMPSSSORelayStateParameterName,
				wildCardFields.RCNiMPSSSOSpentityId,
				wildCardFields.RCNiMPSSSOSpentityIdParameterName
			);
		} else if (isRcniLearningModule(wildCardFields?.WildCardContentTemplateId)) {
			contentDetailsItem = mapLearningModuleToContentDetails(
				id ?? '',
				fields,
				wildCardFields.RCNiSAMLIdPBaseUrl,
				wildCardFields.RCNiImpelsysSSORelayStateParameterName,
				wildCardFields.RCNiImpelsysSSOSpentityId,
				wildCardFields.RCNiImpelsysSSOSpentityIdParameterName
			);
		}

		return contentDetailsItem;
	} catch (error) {
		console.error(error);
		return null;
	}
}
